import React from "react";
import { Parallax } from "react-parallax";

import Header from "./Header";

const Hero = () => {
  return (
    <section className="min-h-[618px] lg:min-h-[815px] pt-9 ">
      <div className="container mx-auto">
        <Header />
        <div className="flex flex-col items-center lg:flex-row lg:items-start pt-20 md:pt-2">
          <div className="flex-1 lg:mt-12">
            <h1 data-aos='fade-down' data-aos-delay='500' className="h1 mb-3 lg:mb-[22px] lg:mt-16">
              Yoga to <br /> Release Stress
            </h1>
            <p data-aos='fade-down' data-aos-delay='600' className="mb-6 lg:mb-12 max-w-[480px] lg:text-lg">
              Yoga is a way of life, rather than a chore. Counteract the
              stresses of modern life by becoming more mindful and
              compassionate.
            </p>
            <div data-aos='fade-down' data-aos-delay='700' className="mb-12 space-x-4">
              <button className="btn btn-sm lg:btn-lg text-heading bg-transparent border border-stroke-1 px-4 hover:bg-stroke-3 transition">
              Learn More
              </button>
            </div>
          </div>

          <div className="w-full bg-cover lg:bg-none lg:w-auto">
            <div data-aos='fade-left' data-aos-delay='600' className="flex-1 flex justify-center lg:justify-end">
              <div className="w-[200px] h-[280px] lg:w-[390px] lg:h-[674px] lg:mt-0">
                <Parallax
                  className="w-full h-full p-28 mt-[-20px] lg:mt-16 lg:p-16"
                  bgImage='https://static.vecteezy.com/system/resources/previews/015/693/458/original/lifestyle-and-yoga-concept-illustration-free-png.png'
                  bgImageAlt="guy image"
                  strength={200}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
